import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, Drawer, TextField, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { QRTYPE } from 'services/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
  ChargeStatusChange
  // GetCharge
} from 'store/actions';
import moment from 'moment';

const Filter = props => {
  const { openFilter, onClose, openCalendar } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const startDate = useSelector(({ charge }) => charge.startDate);
  const endDate = useSelector(({ charge }) => charge.endDate);
  const qrType = useSelector(({ charge }) => charge.qrType);
  const deviceReceipt = useSelector(({ charge }) => charge.deviceReceipt);
  const status = useSelector(({ charge }) => charge.status);

  const handleSubmit = () => {
    // dispatch(GetCharge());
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={openFilter}
      variant="temporary"
    >
      <div className={classes.root}>
        <div className={classes.header}>
          <Button
            onClick={onClose}
            size="small"
          >
            <CloseIcon className={classes.buttonIcon} />
                        Close
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.contentSection}>
            <div className={classes.contentSectionHeader}>
              <Typography variant="h5">Charge filter</Typography>
            </div>
            <div className={classes.contentSectionContent}>
              {/*Device*/}
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  fullWidth
                  label="Device"
                  margin="dense"
                  name="Device"
                  onChange={event => console.log(event.target.value)}
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={deviceReceipt}
                  variant="outlined"
                >
                  {[
                    { value: 'Select all', name: 'Select all' },
                    { value: 'E-commerce', name: 'E-commerce' },
                    { value: 'BNK48', name: 'BNK48' },
                    { value: 'Bottle', name: 'Bottle' },
                    { value: 'Cosmetic', name: 'Cosmetic' },
                    { value: 'Locker', name: 'Locker' }
                  ].map(dev => (
                    <option
                      key={dev.name}
                      value={dev.value}
                    >
                      {dev.name}
                    </option>
                  ))}
                </TextField>
              </div>
              {/* QrType */}
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  fullWidth
                  label="QR type"
                  margin="dense"
                  name="QRtype"
                  onChange={event => console.log(event.target.value)}
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={qrType}
                  variant="outlined"
                >
                  {QRTYPE.map(qr => (
                    <option
                      key={qr.name}
                      value={qr.value}
                    >
                      {qr.name}
                    </option>
                  ))}
                </TextField>
              </div>
              {/* Date */}
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  fullWidth
                  label="Start date"
                  margin="dense"
                  name="Startdate"
                  onClick={() => openCalendar('start')}
                  value={moment(startDate).format('DD-MM-YYYY')}
                  variant="outlined"
                />
              </div>
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  label="End date"
                  margin="dense"
                  name="Enddate"
                  onClick={() => openCalendar('end')}
                  value={moment(endDate).format('DD-MM-YYYY')}
                  variant="outlined"
                />
              </div>
              {/* Amiunt */}
              <Typography
                style={{ flex: 1 }}
                variant="body1"
              >
                                Amount
              </Typography>
              <div className={classes.formGroup}>
                <div className={classes.fieldGroup}>
                  <TextField
                    className={classes.field}
                    margin="dense"
                    name="From"
                    placeholder="00.00"
                    style={{ flex: 2 }}
                    variant="outlined"
                  />
                  <Typography
                    style={{ flex: 1, textAlign: 'center' }}
                    variant="body1"
                  >
                                        To
                  </Typography>
                  <TextField
                    className={classes.field}
                    margin="dense"
                    name="To"
                    placeholder="00.00"
                    style={{ flex: 2 }}
                    variant="outlined"
                  />
                  <Typography
                    style={{ flex: 1, textAlign: 'center' }}
                    variant="body1"
                  />
                </div>
              </div>
              {/* Status */}
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  fullWidth
                  label="Status"
                  margin="dense"
                  name="Status"
                  onChange={event => {
                    dispatch(ChargeStatusChange(event.target.value));
                  }}
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={status}
                  variant="outlined"
                >
                  {[
                    { value: 'Select all', name: 'Select all' },
                    { value: 'Paid', name: 'Paid' },
                    { value: 'Reject', name: 'Reject' }
                  ].map(status => (
                    <option
                      key={status.name}
                      value={status.value}
                    >
                      {status.name}
                    </option>
                  ))}
                </TextField>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.actions}>
          <Button
            color="primary"
            fullWidth
            onClick={() => handleSubmit()}
            type="submit"
            variant="contained"
          >
                        Apply filters
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

Filter.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  openFilter: PropTypes.bool.isRequired
};

export default Filter;

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(0, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));
